import React, { FC } from "react";

import { CLIENT_KIND, OWNER_KIND } from "./CCompanyKinds";
import { CompanyDetailView } from "./CompanyDetailView";
import { CompanyListView } from "./CompanyListView";

/** `/companies` — the user's own companies, the ones stamped on reports. */
export const Companies: FC = () => <CompanyListView kind={OWNER_KIND} />;

/** `/companies/:id` */
export const CompanyDetails: FC = () => <CompanyDetailView kind={OWNER_KIND} />;

/**
 * `/clients` — the companies reports are sent to. Same entity, same
 * views as `/companies`, told apart by the kind (see CCompanyKinds).
 */
export const Clients: FC = () => <CompanyListView kind={CLIENT_KIND} />;

/** `/clients/:id` */
export const ClientDetails: FC = () => <CompanyDetailView kind={CLIENT_KIND} />;
